import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { galleryImages } from '../../data/gallery';
import ImageModal from './ImageModal';
import './Gallery.css';

const Gallery = () => {
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section className="gallery section" id="gallery">
      <div className="container">
        <h2 className="section-title">{t('gallery.title')}</h2>
        <p className="gallery-subtitle">{t('gallery.livePerformances')}</p>
        {galleryImages.length > 0 ? (
          <div className="gallery-grid">
            {galleryImages.map((image) => (
              <div
                key={image.id}
                className="gallery-item"
                onClick={() => setSelectedImage(image)}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  loading="lazy"
                  onError={(e) => {
                    e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="400"%3E%3Crect fill="%239D4EDD" width="400" height="400"/%3E%3Ctext fill="white" font-family="Arial" font-size="24" x="50%25" y="50%25" text-anchor="middle" dy=".3em"%3EImage%3C/text%3E%3C/svg%3E';
                  }}
                />
                <div className="gallery-overlay">
                  <span className="gallery-icon">🔍</span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="gallery-placeholder">
            <p>{t('gallery.livePerformances')}</p>
          </div>
        )}
      </div>
      {selectedImage && (
        <ImageModal
          image={selectedImage}
          onClose={() => setSelectedImage(null)}
        />
      )}
    </section>
  );
};

export default Gallery;

